<div [formGroup]="form">
  <div formGroupName="bankDetailsChange">
    <form-field class="front" label="Registered IBAN" i18n-label="@@support.bankDetails.oldIban.label">
      <input type="text" readonly formControlName="oldIban" placeholder="Loading ..." i18n-placeholder="@@support.bankDetails.oldIban.placeholder">
    </form-field>

    <form-field class="front" label="Registered Bank Name" i18n-label="@@support.bankDetails.oldBankName.label">
      <input type="text" readonly formControlName="oldBankName" placeholder="Loading ..." i18n-placeholder="@@support.bankDetails.oldBankName.placeholder">
    </form-field>

    <form-field class="front" label="Registered Account Holder Name" i18n-label="@@support.bankDetails.oldAccountHolderName.label">
      <input type="text" readonly formControlName="oldBankAccountHolderName" placeholder="Loading ..." i18n-placeholder="@@support.bankDetails.oldAccountHolderName.placeholder">
    </form-field>

    <div class="hline"></div>

    <form-field class="front" label="New IBAN" i18n-label="@@support.bankDetails.newIban.label">
      <input type="text" formControlName="newIban" placeholder="Fill out the new IBAN" i18n-placeholder="@@support.bankDetails.newIban.placeholder">
    </form-field>

    <form-field class="front" label="New Bank Name" i18n-label="@@support.bankDetails.newBankName.label">
      <input type="text" formControlName="newBankName" placeholder="Fill out the new bank name" i18n-placeholder="@@support.bankDetails.newBankName.placeholder">
    </form-field>

    <form-field class="front" label="New Account Holder Name" i18n-label="@@support.bankDetails.newAccountHolderName.label">
      <input type="text" formControlName="newBankAccountHolderName" placeholder="Fill out the new account holder name" i18n-placeholder="@@support.bankDetails.newAccountHolderName.placeholder">
    </form-field>

    <form-field class="front" label="New Branch Name" i18n-label="@@support.bankDetails.newBranchName.label">
      <input type="text" formControlName="newBranchName" placeholder="Fill out the new branch name" i18n-placeholder="@@support.bankDetails.newBranchName.placeholder">
    </form-field>

    <form-field class="front" label="New Bank Address" i18n-label="@@support.bankDetails.newBankAddress.label">
      <input type="text" formControlName="newBankAddress" placeholder="Fill out the new bank address" i18n-placeholder="@@support.bankDetails.newBankAddress.placeholder">
    </form-field>

    <file-uploader [maxSize]="1024 * 5" [allowedTypes]="['png', 'jpg', 'jpeg', 'pdf']" (select)="onFileSelect($event)" (remove)="onFileRemove()"
      class="d-block mb-3">
      <input #file type="file" class="input">
      <ng-template #placeholder>
        <img src="assets/images/icons/upload-passport.svg" alt="">
        <div class="text-primary pt-2 text-sm" i18n="@@support.bankDetails.passport">Passport copy</div>
      </ng-template>
    </file-uploader>

    <form-field class="front textarea" label="Ticket Message" i18n-label="@@support.bankDetails.message.label">
      <textarea formControlName="message" placeholder="Enter your ticket message" rows="5" i18n-placeholder="@@support.bankDetails.message.placeholder"></textarea>
    </form-field>
  </div>
</div>
